import { createEnv } from "@t3-oss/env-core";
import { fly, railway } from "@t3-oss/env-core/presets-zod";
import { z } from "zod";

export const env = createEnv({
  server: {
    PRIV_M2M_ACCESS_TOKEN: z.string(),
  },

  clientPrefix: "PUB_",
  client: {
    PUB_API_URL: z.string().url(),
    PUB_APP_URL: z.string().url(),
    PUB_TUS_ENDPOINT: z.string().url().optional(),
  },

  shared: {
    FLY_MACHINE_ID: z.string().optional(),
    RAILWAY_REPLICA_REGION: z.string().optional(),
    RAILWAY_GIT_COMMIT_SHA: z.string().optional(),
  },

  runtimeEnv: {
    ...import.meta.env,
    ...process.env,
  },

  emptyStringAsUndefined: true,
  extends: [fly(), railway()],
});
